// VERSION-SURFACING.md §4.4 — single fetch of /api/version, cached for the
// session via react-query. The badge itself renders from build-time env vars
// so a missing/offline API never blanks the chip.
import { APICore } from "./apiCore";

const api = new APICore();

export interface ApiVersionInfo {
  service: string;
  version: string;
  commit: string;
  commit_full?: string;
  branch: string;
  build_time: string;
  env_tier: string;
  node_version?: string;
  uptime_seconds?: number;
}

export function getApiVersion() {
  return api.get(`/api/version`, {});
}
